import * as React from 'react';
import type { SVGProps } from 'react';
import { IconProps } from '.';

export const MedicalBagIllustration: React.FC<IconProps> = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={58} height={50} viewBox="0 0 58 47" fill="none" {...props}>
    <path
      fill="#E6E6E6"
      d="M38.37 1.092H19.565a4.7 4.7 0 0 0-3.325 1.372 4.68 4.68 0 0 0-1.377 3.313v5.857h4.114v-4.1c0-.621.248-1.217.689-1.656a2.36 2.36 0 0 1 1.662-.686h15.28c.624 0 1.222.246 1.663.686.44.44.688 1.035.688 1.656v4.1h4.115V5.777a4.67 4.67 0 0 0-1.378-3.313 4.7 4.7 0 0 0-3.324-1.372"
    />
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M38.37 1.092H19.565a4.7 4.7 0 0 0-3.325 1.372 4.68 4.68 0 0 0-1.377 3.313v5.857h4.114v-4.1c0-.621.248-1.217.689-1.656a2.36 2.36 0 0 1 1.662-.686h15.28c.624 0 1.222.246 1.663.686.44.44.688 1.035.688 1.656v4.1h4.115V5.777a4.67 4.67 0 0 0-1.378-3.313 4.7 4.7 0 0 0-3.324-1.372"
    />
    <path
      className="fill-primary"
      d="M33.67 35.06h5.29c.467 0 .915-.186 1.246-.515.33-.33.516-.776.516-1.242v-5.857c0-.466-.185-.913-.516-1.242-.33-.33-.78-.515-1.247-.515h-5.29v-5.27c0-.467-.185-.913-.516-1.243-.33-.33-.779-.515-1.246-.515H26.03c-.468 0-.916.185-1.247.515-.33.33-.516.776-.516 1.242v5.271h-5.29a1.77 1.77 0 0 0-1.629 1.085 1.8 1.8 0 0 0-.134.672v5.857c0 .466.186.912.516 1.242.331.33.78.515 1.247.515h5.29v5.27c0 .466.185.913.516 1.243.33.33.779.514 1.247.514h5.877c.467 0 .916-.185 1.246-.514.331-.33.517-.777.517-1.243z"
    />
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M33.67 35.06h5.29c.467 0 .915-.186 1.246-.515.33-.33.516-.776.516-1.242v-5.857c0-.466-.185-.913-.516-1.242-.33-.33-.78-.515-1.247-.515h-5.29v-5.27c0-.467-.185-.913-.516-1.243-.33-.33-.779-.515-1.246-.515H26.03c-.468 0-.916.185-1.247.515-.33.33-.516.776-.516 1.242v5.271h-5.29a1.77 1.77 0 0 0-1.629 1.085 1.8 1.8 0 0 0-.134.672v5.857c0 .466.186.912.516 1.242.331.33.78.515 1.247.515h5.29v5.27c0 .466.185.913.516 1.243.33.33.779.514 1.247.514h5.877c.467 0 .916-.185 1.246-.514.331-.33.517-.777.517-1.243z"
    />
    <path
      fill="#E6E6E6"
      d="M51.301 11.634h-8.816c2.339 0 4.58.925 6.234 2.573a8.77 8.77 0 0 1 2.582 6.212v18.74a8.77 8.77 0 0 1-2.582 6.212 8.83 8.83 0 0 1-6.234 2.573h8.816a4.7 4.7 0 0 0 3.324-1.373 4.68 4.68 0 0 0 1.377-3.312v-26.94a4.68 4.68 0 0 0-1.377-3.313 4.7 4.7 0 0 0-3.324-1.373"
    />
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeWidth={1.8}
      d="M3.886 12.831s13.338-1.407 25.88-1.407c8.116.043 16.223.513 24.288 1.407.517 0 1.012.205 1.378.569s.57.858.57 1.373c.536 4.693.805 9.413.806 14.136 0 7.804-.806 17.079-.806 17.079 0 .515-.205 1.009-.57 1.373a1.95 1.95 0 0 1-1.378.568s-11.745.979-24.288.979c-12.542 0-25.88-.979-25.88-.979a1.95 1.95 0 0 1-1.378-.568 1.94 1.94 0 0 1-.57-1.373S1 36.713 1 28.909c.002-4.727.315-9.45.937-14.136 0-.515.206-1.009.571-1.373s.86-.569 1.378-.569Z"
    />
  </svg>
);
